import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';

interface UpdateVehicleVinParams {
  vehicleId: string;
  vin: string;
  vehicleName?: string;
  vehicleModel?: string;
  vehicleYear?: number;
}

interface UpdateVehicleVinResponse {
  success: boolean;
  message: string;
  vehicle: any;
}

const updateVehicleVin = async (
  token: string,
  params: UpdateVehicleVinParams
): Promise<UpdateVehicleVinResponse> => {
  driverApi.setAuthToken(token);
  return driverApi.updateVehicleVin(params.vehicleId, params.vin, {
    vehicleName: params.vehicleName,
    vehicleModel: params.vehicleModel,
    vehicleYear: params.vehicleYear,
  });
};

export const useUpdateVehicleVin = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();

  return useMutation<UpdateVehicleVinResponse, Error, UpdateVehicleVinParams>({
    mutationFn: async (params: UpdateVehicleVinParams) => {
      const token = await getAccessTokenSilently();
      return updateVehicleVin(token, params);
    },
    onSuccess: () => {
      // The board refetches with the new vehicle. An optimistic write here
      // treated the board's list of calls as one call and spread a vehicle
      // into it, which the next refetch had to repair.
      queryClient.invalidateQueries({ queryKey: ['driver-calls'] });
    },
  });
};
